import { FormGroup } from '@angular/forms';

import { ActionType, IContractLot, ILot, ModeType } from 'src/app/models/generic';

import { ICommission, IParametersCommission } from './commission';
import { DetailLotEnum } from './generic';

export enum DialogTypeEnum {
  Confirmation = 1,
  Optional = 2,
  OptionalWithField = 3
}

export enum DialogContractTypeEnum {
  EditContract = 1,
  ViewContract = 2,
  AddContract = 3
}

export enum DialogEmailEnum {
  Transfer = 1,
  Invoicing = 2
}

export interface IDialogData<GenericTemplate> {
  template: GenericTemplate;
  type: number | string;
}

export type DialogAppearance = 'legacy' | 'modern';
export type DialogVariant = 'default' | 'batch-preview';

export interface IDialogConfirm extends IDialogData<IDialogMessages> {
  appearance?: DialogAppearance;
  variant?: DialogVariant;
}

export interface IDialogMessages {
  title: string;
  boldTitle?: string;
  description?: string;
  confirm: string;
  dismiss?: string;
  dismissClass?: string;
  boldWord?: string;
  textInit?: string;
}

export interface IBeneficiaryFormDialogData {
  form: FormGroup<any>;
  editableFields: string[];
  contractId?: string;
}

export interface IBeneficiaryComissionFormDialogData {
  contractId: string;
  justificationCommission: string;
  hasSubstitutedBeneficiary: boolean;
}

export interface IBeneficiaryCredimorarFormDialogData {
  contractId: string;
  beneficiaryId: string;
  amount: number;
}

export interface IDialogContractData
  extends IDialogData<IDialogTemplateContractData> {}

export interface IManagementContractsModalData
  extends IDialogData<IDialogTemplateContractData> {
  lot?: ILot;
  newLots?: ILot[];
  contractsInLots?: IContractLot[];
  typeLot?: DetailLotEnum;
}

export interface IDialogTemplateCommissionData {
  title: string;
  parameters: IParametersCommission;
  commissionCardId: string;
}

export interface IDialogTemplateContractData {
  title: string;
  description?: string;
  textConfirmButton: string;
  typeLot?: DetailLotEnum;
}
export interface IDialogCommissionData
  extends IDialogData<IDialogTemplateCommissionData> {}
